query TagType($id: ID!) {
  tagType(id: $id) {
    id
    title
    defaultPreviewType
    customFields {
      type
      name
      label
      required
      multiple
      placeholder
      helperText
      options {
        value
        label
      }
    }
  }
}
